import React from "react";
import TagInputs from "../../inputs/TagInputs";
import toast from "react-hot-toast";
import { put } from "../../../utility/fetch";

const SettingHMO = ({ nextStep, data,pic, name, email }) => {
    const [payload, setPayload] = React.useState({
        hmo: data?.hmo || "",
        hmoId: data?.hmoId || "",
        validity: data?.validity || "",
        coverageType: data?.coverageType || "",
        city: data?.city || "",
    });
    const [groupLoading, setGroupLoading] = React.useState(false);

    const updateProfile = async () => {
            setGroupLoading(true);
            const response = await put(`/Patient/${data?.id}`, payload);
            if (response.statusCode === 200) {
                toast.success("You have successfully updated your profile");
            } else {
                toast.error("Error updating profile");
            }
            setGroupLoading(false);
        };
    return (
        <div className="card p-40">
            <div className="profile-header m-b-40 flex space-between">
                <div className="flex">
                    <img src={pic || "user-avater.png"} alt="User" className="profile-pic" />
                    <div className="m-l-10">
                        <h3>{`${name|| ""}`}</h3>
                        <p>{email || ""}</p>
                    </div>
                </div>
                <button
                    disabled={groupLoading}
                    className="save-drafts col-3"
                    onClick={updateProfile}
                >
                    Save Changes
                </button>
            </div>

            <div className="flex space-between">
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs label='HMO' type="text" value="Gabriel Dickson Williams" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='HMO ID' value='female' />

                    </div>
                    <div className="form-group">
                        <TagInputs label='Validity' value='Nigerian' />
                    </div>
                    
                </form>
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs label='Coverage Type' type="text" value="Gabriel Dickson Williams" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='City' value='female' />
                    </div>
                    
                    
                </form>
            </div>

            <button className="submit-btn col-4">View Insurance Coverage Details</button>
            
        </div>
    )
}

export default SettingHMO;